import { render, staticRenderFns } from "./quit.vue?vue&type=template&id=3962c604&scoped=true&"
import script from "./quit.vue?vue&type=script&lang=js&"
export * from "./quit.vue?vue&type=script&lang=js&"
import style0 from "./quit.vue?vue&type=style&index=0&id=3962c604&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3962c604",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3962c604')) {
      api.createRecord('3962c604', component.options)
    } else {
      api.reload('3962c604', component.options)
    }
    module.hot.accept("./quit.vue?vue&type=template&id=3962c604&scoped=true&", function () {
      api.rerender('3962c604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/order/components/quit.vue"
export default component.exports